import { TextField, styled } from '@mui/material';
import { formHelperTextClasses } from '@mui/material/FormHelperText';
import { inputAdornmentClasses } from '@mui/material/InputAdornment';
import { iconButtonClasses } from '@mui/material/IconButton';
import { inputLabelClasses } from '@mui/material/InputLabel';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';

// Mode-aware: en OSCURO texto blanco + borde/label gris claro (como antes); en CLARO
// texto NEGRO + borde NEGRO marcado + label/placeholder oscuros (sin esto el input se
// pierde sobre la card blanca). El foco va en dorado en ambos modos.
const StyledTextField = styled(TextField)(({ theme }) => {
  const isLight = theme.palette.mode === 'light';
  // Borde/label NEGROS y notorios en claro (el usuario los quería bien marcados, no gris
  // tenue). Mismos valores que StyledSelect/StyledPassword para consistencia entre campos.
  const borderColor = isLight ? 'rgba(17, 21, 27, 0.6)' : '#E3E7EB';
  const labelColor = isLight ? 'rgba(17, 21, 27, 0.82)' : '#E3E7EB';
  const textColor = isLight ? theme.palette.text.primary : theme.palette.common.white;
  const adornmentColor = isLight ? 'rgba(17, 21, 27, 0.7)' : '#E3E7EB';
  const focusColor = theme.palette.secondary.main;

  return {
    [`& .${outlinedInputClasses.root}`]: {
      '& fieldset': {
        border: `1px solid ${borderColor}`
      },
      '&:hover fieldset': {
        borderColor: isLight ? 'rgba(17, 21, 27, 0.8)' : theme.palette.secondary.main
      },
      [`&.${outlinedInputClasses.focused}`]: {
        '& fieldset': {
          borderColor: focusColor
        },
        [`& .${inputAdornmentClasses.root}`]: {
          color: focusColor
        }
      },
      [`&.${outlinedInputClasses.error}`]: {
        '& fieldset': {
          borderColor: '#F6B1B1'
        },
        [`& .${inputAdornmentClasses.root}`]: {
          color: '#F6B1B1'
        },
        [`& .${iconButtonClasses.root}`]: {
          color: '#F6B1B1'
        }
      },
      [`&.${outlinedInputClasses.disabled}`]: {
        '& fieldset': {
          borderColor: theme.palette.action.disabled
        },
        [`& .${inputAdornmentClasses.root}`]: {
          color: theme.palette.action.disabled
        }
      }
    },
    [`& .${inputLabelClasses.root}`]: {
      color: labelColor,
      [`&.${inputLabelClasses.focused}`]: {
        color: focusColor
      },
      [`&.${inputLabelClasses.error}`]: {
        color: '#F6B1B1'
      },
      [`&.${inputLabelClasses.disabled}`]: {
        color: theme.palette.action.disabled,
        [`& .${inputLabelClasses.asterisk}`]: {
          color: theme.palette.action.disabled
        }
      }
    },
    [`& .${inputLabelClasses.asterisk}`]: {
      color: labelColor,
      [`&.${inputLabelClasses.error}`]: {
        color: '#F6B1B1'
      }
    },
    [`& .${outlinedInputClasses.input}`]: {
      color: textColor,
      '&::placeholder': { color: labelColor, opacity: 1 },
      [theme.breakpoints.up('lg')]: {
        height: '14px'
      },
      [`&.${outlinedInputClasses.disabled}`]: {
        color: theme.palette.action.disabled
      }
    },
    [`& .${formHelperTextClasses.root}`]: {
      marginLeft: 0,
      [`&.${formHelperTextClasses.error}`]: {
        color: '#F6B1B1'
      }
    },
    [`& .${inputAdornmentClasses.root}`]: {
      color: adornmentColor,
      [`&.${outlinedInputClasses.disabled}`]: {
        color: theme.palette.action.disabled
      }
    }
  };
});

export default StyledTextField;
